import { render, staticRenderFns } from "./showDifRev.vue?vue&type=template&id=f056269c&"
import script from "./showDifRev.vue?vue&type=script&lang=js&"
export * from "./showDifRev.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports